module.exports = __webpack_public_path__ + "img/title3_6.4f17198a.png";